import { useMemo, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery } from '@apollo/client';
import { GET_STATIONS } from 'store/queries';

const filteredStations = ['8400058', '8814001', '8722326', '7015400', '8727100', '8400530'];

const useStations = () => {
  const { data, loading } = useQuery(GET_STATIONS, {
    fetchPolicy: 'cache-first'
  });

  const stations = useMemo(() => {
    if (!data?.stations) {
      return [];
    }

    return data.stations.filter((station) => filteredStations.includes(station.uic)).sort((lhs, rhs) => lhs.name.localeCompare(rhs.name));
  }, [data]);

  return {
    stations,
    loading
  };
};

export const useLuggageForm = (onSubmitSearch) => {
  const form = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      station: '',
      date: ''
    }
  });

  const { stations, loading } = useStations();

  useEffect(() => {
    form.register('date', { required: true });
    form.register('station', { required: true });

    form.watch('station');
    form.watch('date');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (stations.length) {
      form.setValue('station', stations[0].uic, {
        shouldValidate: true
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!form, stations]);

  return {
    onSubmit: form.handleSubmit(onSubmitSearch),
    form,
    loading,
    stations
  };
};
